var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"s-filial-item",class:{
    selected: _vm.selected,
    's-select-value': _vm.isSelectValue,
    's-list-item': _vm.isListItem,
  }},[_c('div',{staticClass:"s-filial-item__icon"},[_c(_vm.itemIcon,{tag:"component"})],1),_c('div',{staticClass:"s-filial-item__content"},[_c('div',{staticClass:"s-filial-item__address"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',{staticClass:"s-filial-item__city"},[_vm._v(" "+_vm._s(_vm.item.description)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }